/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbDeliberationMasseGridDto } from './FcbDeliberationMasseGridDto';
import {
    FcbDeliberationMasseGridDtoFromJSON,
    FcbDeliberationMasseGridDtoFromJSONTyped,
    FcbDeliberationMasseGridDtoToJSON,
} from './FcbDeliberationMasseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbDeliberationMasseGridDtoPaginatedResults
 */
export interface FcbDeliberationMasseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbDeliberationMasseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbDeliberationMasseGridDto>}
     * @memberof FcbDeliberationMasseGridDtoPaginatedResults
     */
    results?: Array<FcbDeliberationMasseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbDeliberationMasseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbDeliberationMasseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbDeliberationMasseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbDeliberationMasseGridDtoPaginatedResultsFromJSON(json: any): FcbDeliberationMasseGridDtoPaginatedResults {
    return FcbDeliberationMasseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbDeliberationMasseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbDeliberationMasseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbDeliberationMasseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbDeliberationMasseGridDtoPaginatedResultsToJSON(value?: FcbDeliberationMasseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbDeliberationMasseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

